export * from './menus';

import { BookmarkActions } from './menus';

export enum SearchUser {
  SearchInOrganisation = 'SearchInOrganisation',
  SearchAllUsers = 'SearchAllUsers',
  CreateUser = 'CreateUser'
}

export enum FileFormat {
  PDF = 'Pdf',
  PPTX = 'Pptx',
  ZIP = 'zip'
}

export const NewDraftState = 'NewDraft';
export const exportInProgress = 'exportInProgress';
export const discardSuccessMessage = 'Draft deleted successfully';
export const exportMessage = 'Your export has been initiated. Download may take some time';
export const bookmarkMessage = (action: BookmarkActions) => `The bookmark has been ${action}`;
export const changeBookmarkDefaultMessage = 'Default bookmark has been updated';
export const clearBookmarkDefaultMessage = 'Default bookmark has been cleared';
export const noUsersFoundMessage = 'No user found matching search criteria';
export const domainNameWarning = (domainName: string, userDetail?: string) =>
  `${
    userDetail ?? 'Selected user'
  }'s email address does not match your domain (${domainName}). Please verify this is correct before adding user`;
export const userOnboardInfo = (userDetail: string) =>
  `${userDetail} will be available to onboard to other purchased MRI products`;
export const noUserSelectedMessage = 'No User Selected';
export const createUserPromptMessage = (clientId: string) =>
  `This action will create and add the user to the client ${clientId}. Do you wish to continue?`;
export const userPermissionChangePrompt = (title: string) =>
  `The changes that you have selected will impact your access to ${title}. You will be navigated from the current page. Do you wish to continue?`;
export const filterSavePrompt =
  'Saving this filter might undo your changes in the current page. Do you wish to continue?';
export const resetFiltersPrompt = "Do you want to reset filters, slicers, and other data view changes you've made?";
export const clearBookmarkPrompt = 'Do you want to clear the current bookmark?';
export const resetFiltersAndBookmarkPrompt =
  'Do you want to reset filters, slicers, and other data view changes with the current bookmark?';
export const updateModulePrompt = (workspaceNames: string) =>
  `The following workspace modules contain custom reports: ${workspaceNames}` +
  `\nIf you proceed to remove these modules all the associated reports will be deleted. This action cannot be undone`;
export const userLogoutMessage = 'If you delete this user you will be logged out. Are you sure you want to proceed?';
export const bookmarkPublishFailedTooltip =
  'Bookmark menu unavailable due to a publish failure. Reload the dashboard to restore.';
export const downloadPbirPrompt =
  "Before downloading, please ensure the setting 'Store PBIR reports using enhanced metadata format (PBIR)' (File > Options and settings > Options > Preview features) is disabled in your Power BI Desktop.\nDo you want to proceed with the download?";

export const isClientOnboarding = 'isClientOnboarding';
export const isClientRecovery = 'isClientRecovery';
